import { Component, DOCUMENT, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import {Router} from '@angular/router';
import { GalleryHomeTopComponent } from './gallery/gallery-home-top.component';
import { HomeAboutUsComponent } from './home-about-us.component';
import { HomeCateringComponent } from './home-catering.component';
import { HomeWeeklyCateringComponent } from './home-weekly-catering.component';
import { GalleryNewComponent } from './gallery/gallery-new.component';
import { FooterComponent } from './footer/footer.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [GalleryHomeTopComponent, NgClass, HomeAboutUsComponent, HomeCateringComponent, HomeWeeklyCateringComponent, GalleryNewComponent, FooterComponent]
})
export class HomeComponent {
    private document = inject<Document>(DOCUMENT);
    private router = inject(Router);

    selectedMenu = 0;

    getSelectedMenu(m: number) {
        let elmnt;
        this.selectedMenu = m;
        if (this.selectedMenu === 1) {
            elmnt = document.getElementById('catering');
            elmnt.scrollIntoView();
        }
        if (this.selectedMenu === 2) {
            elmnt = document.getElementById('weeklycatering');
            elmnt.scrollIntoView();
        }
    }

    goToMenu(): void {
        this.router.navigate(['fullmenu', 'menuitem'], {skipLocationChange: true});
    }

    goToYoello() {
        this.document.location.href = 'https://pay.yoello.com/v/bddine';
    }

}
